import { useCallback, useContext, useState } from "react";
import { getGraphsData, unlockVolSurfaceStickyStrikes, updateOnEditCell } from "api/volSurfaceApi";
import { VolSurfaceContext } from "contexts/VolSurfaceContext";
import { useVolSurfaceControlTable } from "contexts/VolSurfaceControlTableContext";
import { revertCellValue, setDataToLocalStorage } from "helpers/generalHelper";
import {
  updateGraph,
  updateVolSurfaceBodyData,
  updateVolSurfaceData,
  updateVolSurfaceEstimateData,
} from "helpers/volSurfaceHelper";
import { SCROLL_POSITION } from "constants/volSurface";

function useUpdateControlTable({ scrollableRef, gridRef }) {
  const {
    setIsCellEditing,
    setVolSurfaceData: setRowsData,
    setRowEditingData,
    selectedFilters,
    volSurfaceTablesData: rowsData,
    setVolCalcTable,
    volCalcTable,
    setScrollPosition,
    setLockedData,
    lockedData,
  } = useVolSurfaceControlTable();

  const {
    state: { volSurfaceData },
    setVolSurfaceData,
  } = useContext(VolSurfaceContext);

  const onCellEditingStopped = useCallback(
    (event) => {
      +event.oldValue === +event.newValue && setIsCellEditing(false);
      +event.oldValue === +event.newValue && setIsCellEditing(false);
      if (+event.oldValue === +event.newValue) return;

      const { prepareBody, bodyForUnderlying } = updateVolSurfaceBodyData(
        event,
        selectedFilters
      );
      if (!selectedFilters?.comparison_surface_id) {
        delete prepareBody.comparison_surface_id;
        delete bodyForUnderlying.comparison_surface_id;
      }
      setIsCellEditing(true);
      setScrollPosition(scrollableRef.current.scrollTop);
      setDataToLocalStorage(SCROLL_POSITION, scrollableRef.current.scrollTop);
      updateOnEditCell(
        event.colDef.headerName === "Tenor" ? bodyForUnderlying : prepareBody
      )
        .then((res) => {
          const response = res?.data?.data;
          if (res.status === 423) {
            setLockedData({
              model_id: response?.model_id,
              model: response?.model,
              show_lock_modal: true,
              is_locked: true,
              locked_by: res?.data?.message,
              lock_comparison_surface_dropdown:
                lockedData?.lock_comparison_surface_dropdown,
              event: event,
            });
          } else if (res.status !== 200) {
            revertCellValue(event);
          } else {
            const updatedData = updateVolSurfaceData(
              response?.control_table_rows,
              rowsData
            );
            setRowsData(updatedData);
            if (response.graphs_data) {
              updateGraph(res, volSurfaceData);
              setVolSurfaceData(volSurfaceData);
            }
            const volCalcTableUpdatedData = updateVolSurfaceEstimateData(
              response.vol_calc_table_rows,
              volCalcTable
            );
            setVolCalcTable(volCalcTableUpdatedData);

            let refreshParams = { force: true };
            gridRef.current.api.refreshCells(refreshParams);
            setIsCellEditing(false);
            setRowEditingData(null);
            if (event.colDef.headerName === "Tenor") {
              getGraphsData({
                product_contract_style_id: selectedFilters?.product_id,
                risk_free: selectedFilters?.risk_free,
                comparison_surface_id: selectedFilters?.comparison_surface_id,
              }).then((res) => {
                const response = res?.data?.data;
                setVolSurfaceData(response);
              });
            }
          }
        })
        .catch((e) => {
          revertCellValue(event);

          console.log("Error while setting data");
          setIsCellEditing(false);
          setRowEditingData(null);
        });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      rowsData,
      selectedFilters,
      setIsCellEditing,
      setRowEditingData,
      volSurfaceData,
    ]
  );

  return { onCellEditingStopped,revertCellValue };
}

export default useUpdateControlTable;
